/*
 * DO NOT EDIT
 * ===========
 * This file was auto-generated.
 * To update run the TypeScript Code Generator in the API.
 */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { ActivateDeactivateAssetGroupCommand } from '../models/asset-groups/activate-deactivate-asset-group.command';
import { UpdateAssetGroupCommand } from '../models/asset-groups/update-asset-group.command';
import { UpdateAssetGroupResponse } from '../models/asset-groups/update-asset-group.response';
import { UpsertGlAccountsCommand } from '../models/asset-groups/upsert-gl-accounts.command';
import { UpsertGlAccountsResponse } from '../models/asset-groups/upsert-gl-accounts.response';
import { GetAssetGroupResponse } from '../models/get-asset-group.response';

@Injectable({
  providedIn: 'root',
})
export class AssetGroupV2Api {
  constructor(private http: HttpClient) {}

  getAssetGroup(id: number): Observable<GetAssetGroupResponse> {
    return this.http.get<GetAssetGroupResponse>(
      `${environment.servicesApiUrl}/api/v2/assetgroups/${id}`,
    );
  }

  setActive(command: ActivateDeactivateAssetGroupCommand): Observable<UpdateAssetGroupResponse> {
    return this.http.post<UpdateAssetGroupResponse>(
      `${environment.servicesApiUrl}/api/v2/assetgroups/${command.assetGroupId}/active`,
      command,
    );
  }

  updateAssetGroup(command: UpdateAssetGroupCommand): Observable<UpdateAssetGroupResponse> {
    return this.http.put<UpdateAssetGroupResponse>(
      `${environment.servicesApiUrl}/api/v2/assetgroups/${command.assetGroupId}`,
      command,
    );
  }

  upsertGlAccounts(command: UpsertGlAccountsCommand): Observable<UpsertGlAccountsResponse> {
    return this.http.put<UpsertGlAccountsResponse>(
      `${environment.servicesApiUrl}/api/v2/assetgroups/${command.assetGroupId}/glAccounts`,
      command,
    );
  }
}
